import { createStyles, palette, spacing } from "../../../styles/theme";

export const CheckoutStyles = createStyles({
  container: {
    backgroundColor: palette.white,
    gap: { xs: spacing.wrapperMobile, md: spacing.wrapperDesktop },
    padding: { xs: spacing.wrapperMobile, lg: spacing.wrapperDesktop },
    border: `1px solid ${palette.grey.lightGrey}`,
    borderRadius: "8px",
    width: "100%",
  },
});
